import React, { FC } from 'react';

import { CtaImageBox } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-index';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

export const LandingSubscribeContainer: FC = () => {
  const isTablet = useMediaQuery(MediaQueryWidth['desktop-md']);
  const isMobile = useMediaQuery(MediaQueryWidth['tablet-sm']);
  const imageSrc = '/project-love/assets/subscribe-image-desktop-new.jpg';
  const imageOverlaySrc = '/bumble-brand-assets/project-love/assets/member-circle.svg';
  let offset = '50px';
  let overlayWidth = '208px';
  if (isMobile) {
    overlayWidth = '104px';
    offset = '20px';
  } else if (isTablet) {
    overlayWidth = '120px';
    offset = '30px';
  }

  return (
    <CtaImageBox
      title={lexemes.lxPageIndexSubscribeTitle}
      description={lexemes.lxPageIndexSubscribeDescription}
      cta={{
        text: lexemes.lxPageIndexSubscribeCta,
        href: 'https://bumblecx.qualtrics.com/jfe/form/SV_cN3ZPm5KkQAuVAG',
      }}
      image={{
        src: imageSrc,
        alt: lexemes.lxPageIndexSubscribeAlt,
      }}
      imageOverlay={
        <img
          style={{
            position: 'absolute',
            bottom: offset,
            left: offset,
            width: overlayWidth,
            height: 'auto',
          }}
          src={imageOverlaySrc}
          alt="Member circle stamp"
        />
      }
      isHtml={true}
      imagePosition="start"
    />
  );
};
